export class ClientSearchViewModel {
  Filter: string;
  Type: string;
  Status: string;
  OrgId: number;
  OrderId: number;
}
